import { ChangeEvent, Children, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Equipment from 'model/Equipment';
import { DEVICE_MODAL_TYPE } from 'types/enumType';
import { convertDeviceTypeToString } from 'util/commonUtil';

import QrcodeModal from './modal/QrcodeModal';

type EquipTableProps = {
  type: DEVICE_MODAL_TYPE;
  factoryId: string;
  list: Equipment[];
  isAdmin: boolean;
  onRegister: (type: DEVICE_MODAL_TYPE) => void;
  onClickDetail: (type: DEVICE_MODAL_TYPE, id: number) => void;
  isAvailableDevice: (type: DEVICE_MODAL_TYPE) => boolean;
};

export default function EquipTable({
  type,
  factoryId,
  list,
  isAdmin,
  isAvailableDevice,
  onRegister,
  onClickDetail,
}: EquipTableProps) {
  const { t } = useTranslation();

  const [checkedEquipList, setCheckedEquipList] = useState<number[]>([]);
  const [isAllChecked, setIsAllChecked] = useState<boolean>(false);

  const onCheckedEquipItem = (
    event: ChangeEvent<HTMLInputElement>,
    equipId: number,
  ) => {
    if (event.target.checked) {
      setCheckedEquipList((prev) => prev.concat(equipId));
      if (checkedEquipList.concat(equipId).length === list.length) {
        setIsAllChecked(true);
      }
    } else {
      setCheckedEquipList((prev) => prev.filter((id) => id !== equipId));
      if (isAllChecked) {
        setIsAllChecked(false);
      }
    }
  };
  const toggleAllChecked = (event: ChangeEvent<HTMLInputElement>) => {
    setIsAllChecked(event.target.checked);

    if (event.target.checked) {
      setCheckedEquipList(list.map((item) => item.id));
    } else {
      setCheckedEquipList([]);
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);
  const onClick = () => {
    setConfirmIsOpen(true);
  };
  // const confirmClose = () => {
  //   setConfirmIsOpen(false);
  // }

  const modalHandler = () => {
    if (checkedEquipList.length === 0) {
      alert(t('validation.choiceDevice'));
      return;
    }

    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setConfirmIsOpen(false);
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  useEffect(() => {
    setIsAllChecked(false);
    setCheckedEquipList([]);
  }, [list]);

  return (
    <>
      <section>
        <div className={'subtit'}>
          <p>{convertDeviceTypeToString(type)}</p>
          <span>
            {isAdmin && (
              <button
                className={'orange_white_btn mg15r'}
                type={'button'}
                onClick={modalHandler}
              >
                {t('device.qrCreate')}
              </button>
            )}
            {isAvailableDevice(type) && isAdmin && (
              <button
                className={'orange_white_btn'}
                type={'button'}
                onClick={() => onRegister(type)}
              >
                {t('device.regist')}
              </button>
            )}
          </span>
        </div>
        <div className={'tbl-wrap equip-wrap'}>
          <table className={'tbl_ht01'}>
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                {isAdmin && (
                  <th aria-label={'th'}>
                    <input
                      type={'checkbox'}
                      checked={isAllChecked}
                      onChange={toggleAllChecked}
                    />
                  </th>
                )}
                <th>{t('device.equipCode')}</th>
                <th>{t('device.deviceName')}</th>
                <th>{t('user.deptName')}</th>
                <th>{t('device.mdmCode')}</th>
                <th>{t('device.useStatus')}</th>
              </tr>
            </thead>
            <tbody>
              {!list || list?.length === 0 ? (
                <tr>
                  <td colSpan={6}>{t('conclusion.noData')}</td>
                </tr>
              ) : (
                Children.toArray(
                  list.map((device) => (
                    <tr
                      onClick={() => onClickDetail(type, device.id)}
                      className={device.activate === 'N' ? 'redrow' : ''}
                    >
                      {isAdmin && (
                        <td onClick={handleClick} aria-label={'td'}>
                          <input
                            type={'checkbox'}
                            data-code={device.code}
                            checked={
                              !!checkedEquipList.find(
                                (item) => item === device.id,
                              )
                            }
                            onChange={(event) =>
                              onCheckedEquipItem(event, device.id)
                            }
                          />
                        </td>
                      )}
                      <td>{device.itemCode}</td>
                      <td className={'left'}>{device.name}</td>
                      <td>{device.deptName ?? t('home.prod')}</td>
                      <td>{device.mdmCode}</td>
                      <td>{device.activate}</td>
                    </tr>
                  )),
                )
              )}
            </tbody>
          </table>
        </div>
      </section>
      <QrcodeModal
        factoryId={factoryId}
        equipIdList={checkedEquipList}
        isOpen={isOpen}
        onClose={handleClose}
        onClick={onClick}
        confirmIsOpen={confirmIsOpen}
      />
    </>
  );
}
